<template>
  <span class="bg-clock-wrap" :class="{ 'tooltip tooltip-left': !!tooltip }"
        :data-tooltip="tooltip">
    <span class="bg-clock" :class="`bg-clock-${info.tone}`">
      <fa-icon :icon="['fal', icon]"/>{{ info.label }}
    </span>
    <span class="bg-clock-hint" v-if="showHint">{{ info.hint }}</span>
  </span>
</template>

<script>
import { deadlineInfo } from '../helpers';

export default {
  props: {
    deadline: {
      type: Object,
      default: null,
    },
    showHint: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    info() {
      return deadlineInfo(this.deadline);
    },
    icon() {
      if (this.info.tone === 'overdue') return 'exclamation-triangle';
      return 'clock';
    },
    tooltip() {
      if (this.showHint || !this.info.hint) return null;
      return `Prazo do recurso · ${this.info.hint}`;
    },
  },
};
</script>
